import { getCompanyById } from '@/services/ws-companies/src/main/resources/rest-api';
import { createContexts } from '@/js/libs/create-contexts';
import { useIdentityUser } from '@/js/libs/use-auth';
import { NotActive, useMappedRequest, useRequest } from '@/js/libs/use-request';

import { useCompanySwitchContext } from 'src/modules/CompaniesSwitch/context';

export const { useNumberFormatContext } = createContexts({
  NumberFormat() {
    const { company: switcherCompany } = useCompanySwitchContext();
    const currentUser = useIdentityUser();
    const userCompany = currentUser?.company;
    const companyId = switcherCompany?.id ?? userCompany?.id;

    const companyRequest = useRequest({
      apiMethod: getCompanyById,
      params: companyId ? { id: companyId } : NotActive,
    });
    const countryRequest = useMappedRequest(companyRequest, (data) => data.countryCode);

    return { countryRequest };
  },
});

export const NumbersFormatContextProvider = useNumberFormatContext.Provider;
